var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar-slot",staticClass:"slot-card__move-behavior",class:{
	'is-smaller': _vm.isSmaller,
	'is-dragging': !!_vm.dragging,
	'is-invalid': _vm.timeIsWrong || _vm.dateIsWrong,
},style:(Object.assign({}, _vm.styles))},[_c('SlotCardTimeString',{attrs:{"slotCard":_vm.slotCard,"isVisible":!!_vm.dragging,"posX":_vm.left,"isInvalid":_vm.timeIsWrong || _vm.dateIsWrong,"currentHour":_vm.currentHour,"currentMinute":_vm.currentMinute,"nearestPlace":_vm.nearestPlace}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }